/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Graduationinformation1Inputs */

const de__field_graduationinformation1 = /** @type {(inputs: _Field_Graduationinformation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CHANCENAbschluss Informationen`)
};

/**

* @param {_Field_Graduationinformation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_graduationinformation1 = /** @type {((inputs?: _Field_Graduationinformation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Graduationinformation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_graduationinformation1(inputs)
});
export { _field_graduationinformation1 as "_field_graduationInformation" }